module.exports = __webpack_public_path__ + "img/art_3_4.3f8b8b87.png";